module.exports = __webpack_public_path__ + "static/fonts/DINProMedium.fd6cadef.eot";